import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  stockAttributesNo: {
    name: "stockAttributesNo",
    label: "Stock Attributes No",
    type: "text",
    editable: false,
    disabled: true, 
    maxLength: 20,
    xs: 3,
  },
  warehouseCode: {
    name: "warehouseCode",
    label: "Warehouse Code",
    type: "select",
    errorMsg: "Warehouse Code is required.",
    required: true,
    maxLength: 20,
    xs: 3,
  },
  customerCode: {
    type: "text",
    name: "customerCode",
    label: "Customer Code",
    errorMsg: "Customer Code is required",
    required: true,
    disabled: true,
    xs: 3,
  },
  reasonCode: {
    name: "reasonCode",
    label: "Reason",
    type: "text",
    errorMsg: "Reason is required",
    required: true,
    maxLength: 20,
    xs: 3,
  },
};

const { stockAttributesNo, warehouseCode, customerCode, reasonCode } = formField;

export const formRender = [[stockAttributesNo, customerCode, warehouseCode, reasonCode]];

export const initialValues = getInitialValues(formField);

export const stockAttributesValidation = Yup.object().shape({
  [stockAttributesNo.name]: Yup.string().nullable().max(stockAttributesNo.maxLength),
  [warehouseCode.name]: Yup.string().nullable().max(warehouseCode.maxLength).required(warehouseCode.errorMsg),
  [customerCode.name]: Yup.string().nullable().required(customerCode.errorMsg),
  [reasonCode.name]: Yup.string().nullable().required(reasonCode.errorMsg).max(reasonCode.maxLength),
});
